import * as Yup from 'yup';

export const postalCode = Yup.string()
  .max(7, 'Postal code should be less than 7 symbols')
  .required('Postal code is required');
